var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintain-page"},[_c('div',{staticClass:"maintain-icon"}),_c('div',{staticClass:"maintain-tip"},[_vm._v(_vm._s(_vm.maintainTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }